module.exports = __webpack_public_path__ + "static/media/04_Matilda.ed18427b.png";